export default __webpack_public_path__ + "static/media/skill.a7a4d23d.svg";